import bmw from '../../assets/carTypes/bmw.svg';
import compact from '../../assets/carTypes/compact.svg';
import convertible from '../../assets/carTypes/convertible.svg';
import coup from '../../assets/carTypes/coup.svg';
import crossover from '../../assets/carTypes/crossover.svg';
import crossover01 from '../../assets/carTypes/crossover01.svg';
import familymbp from '../../assets/carTypes/family-mbp.svg';
import limousine from '../../assets/carTypes/limousine.svg';
import sedan from '../../assets/carTypes/sedan.svg';
import sportcoupe from '../../assets/carTypes/sportcoupe.svg';
import suv from '../../assets/carTypes/suv.svg';
import wagon from '../../assets/carTypes/wagon.svg';

export const carTypes = [
  {
    id: 1,
    title: 'SUV',
    img: suv,
  },
  {
    id: 2,
    title: 'Crossover',
    img: crossover,
  },
  {
    id: 3,
    title: 'Wagon',
    img: wagon,
  },
  {
    id: 4,
    title: 'Family MBP',
    img: familymbp,
  },
  {
    id: 5,
    title: 'Sport Coupe',
    img: sportcoupe,
  },
  {
    id: 6,
    title: 'Compact',
    img: compact,
  },
  {
    id: 7,
    title: 'Coup',
    img: coup,
  },
  {
    id: 8,
    title: 'BMV',
    img: bmw,
  },
  {
    id: 9,
    title: 'Sedan',
    img: sedan,
  },
  {
    id: 10,
    title: 'Limousine',
    img: limousine,
  },
  {
    id: 11,
    title: 'Convertible',
    img: convertible,
  },
  {
    id: 12,
    title: 'Crossover',
    img: crossover01,
  },
];
